import Button from "devextreme-react/button";
import ContextMenu, { Position } from "devextreme-react/context-menu";
import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetCompany } from "../../../../api/company";
import { LoadPagePanel } from "../../../../components";
import { QuoteTypes, ROType } from "../../../../types/enums";
import { showErrorMessage } from "../../../../utils/messages";
import { useCreateEstimate } from "../api/create-estimate";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function CreateEstimateButton() {

	const { order } = useContext(RetailOrderContext);
	const dealer = useGetCompany(order.details.dealerCompanyID);
	const [quoteTypeID, setQuoteTypeID] = useState();

	const navigate = useNavigate();

	const createEstimate = useCreateEstimate(order.details.retailOrderID,
		(result) => {
			if (quoteTypeID === QuoteTypes.EEPro) {
				navigate(`/cfi/easy-estimator/${result.quoteID}`);
			}
			else if (quoteTypeID === QuoteTypes.EasyEstimator2) {
				window.open(dealer.data?.easyEstimatorUrl + '?loadEstimate=' + result.quoteGUID + '&userToken=' + result.eeToken);
			}
			else if (quoteTypeID === QuoteTypes.EasyEstimator3) {
				window.open(dealer.data?.easyEstimatorV3Url + '?loadEstimate=' + result.quoteGUID + '&userToken=' + result.eeToken);
			}
		},
		(error) => showErrorMessage(error));

	const menuItems = useMemo(() => {

		if (!dealer?.data) {
			return [];
		}

		let result = [];

		if (dealer.data.eeShowInPortal && !!dealer.data.easyEstimatorUrl) {
			result.push(
				{
					text: 'Easy Estimator 2.0',
					icon: 'Inscyth-Easy-Estimator',
					quoteTypeID: QuoteTypes.EasyEstimator2
				}
			)
		}

		if (!!dealer.data.easyEstimatorV3Url) {
			result.push(
				{
					text: 'Easy Estimator 3.0',
					icon: 'Inscyth-Easy-Estimator',
					quoteTypeID: QuoteTypes.EasyEstimator3
				}
			)
		}

		result.push({
			text: 'EE Pro Tool',
			icon: 'Inscyth-EEPro',
			quoteTypeID: QuoteTypes.EEPro
		})

		return result;
	}, [dealer.data]);

	return (
		<>
			<Button
				id="create-estimate-button"
				visible={order.details.roTypeID === ROType.Retail || order.details.roTypeID === ROType.Measure}>
				<i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
				Create Estimate
				<i className={'dx-icon dx-icon-chevrondown'}></i>
			</Button>
			<ContextMenu
				width={165}
				items={menuItems}
				target="#create-estimate-button"
				showEvent="click"
				onItemClick={(e) => {
					const data = e.itemData as any;
					setQuoteTypeID(data.quoteTypeID);
					createEstimate.mutate();
				}}
			>
				<Position my='left top' at='left bottom'>
				</Position>
			</ContextMenu>
			<LoadPagePanel visible={createEstimate.isLoading}></LoadPagePanel>
		</>
	)
}
